import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  Box,
  Button,
  ButtonMode,
  ButtonSize,
  PagePanel,
  PlusIcon
} from 'edenred-ui';

import { useGetBenefitGroupsQuery } from '@epi-api/benefitGroups';
import { IBenefitGroup } from '@epi-models/pages/BenefitGroups';

import { BenefitGroupTile } from './components/BenefitGroupTile/BenefitGroupTile';
import { GridContainer } from './BenefitGroups.styles';

export const BenefitGroups = () => {
  const { t } = useTranslation();
  const { primaryFontAltColor, fontMediumBold } = useTheme();
  const benefitGroups = useGetBenefitGroupsQuery();
  benefitGroups.data?.forEach(group => console.log(group.groupId));

  return (
    <Box>
      <PagePanel
        title={t('containers.benefit_groups.title')}
        headerContent={
          <Button
            mode={ButtonMode.Primary}
            onClick={() => {}}
            size={ButtonSize.Medium}
            id="add_benefit_group-btn"
          >
            <Box display={'flex'} gap={1} alignItems="center">
              <PlusIcon color={primaryFontAltColor} />
              <Box fontWeight={fontMediumBold}>
                {t('containers.benefit_groups.add_benefit_group')}
              </Box>
            </Box>
          </Button>
        }
      >
        <GridContainer>
          {benefitGroups.data?.map((data: IBenefitGroup) => (
            <BenefitGroupTile key={data.groupId} benefitGroup={data} />
          ))}
        </GridContainer>
      </PagePanel>
    </Box>
  );
};
